<template>
    <div>
        <van-nav-bar
                title="提货配车"
                left-text=""
                right-text="筛选"
                left-arrow
                fixed
                @click-left="back()"
                @click-right="searchPop()"
                v-if="show"
        />

        <van-nav-bar
                title="提货码"
                left-arrow
                fixed
                v-if="showpop"
                @click-left="showpop=false"
                z-index="9999"
        />
<!--        <van-button v-if="showpop_delbtn()" class="closebutton2" block size="small" type="info" native-type="submit" style="font-size: 16px" @click="detailDel()">-->
<!--            删除-->
<!--        </van-button>-->


        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  >
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <!--                    <van-swipe-cell>-->
<!--                    <van-swipe-cell   >-->
                    <van-cell v-for="item in list" :key="item.truckproveId" class="swipewarp" @click="editFleet(item)"  >
                        <van-row gutter="20">
                            <van-col span="12">{{item.truckproveNo}}</van-col>
                            <van-col span="12" style="text-align: right">
                                <span v-if="showStatus(item)=='yu'">预约<span v-if="showStatus(item)=='yu'"></span> </span>
                                <span v-else-if="showStatus(item)=='jin'">进场</span>
                                <span v-else-if="showStatus(item)=='li'">离场</span>
                            </van-col>
                        </van-row>
                        <van-row gutter="20" style="color: #727272">
                            <van-col span="12">{{item.truckNo}}</van-col>
                            <van-col span="12" style="text-align: right">{{item.driverName}}</van-col>
                        </van-row>

                        <van-row gutter="20" style="color: #727272">
                            <van-col span="12">创建时间</van-col>
                            <van-col span="12" style="text-align: right">{{item.createTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>

                        <van-row v-show="false" gutter="20" style="color: #727272">
                            <van-col span="12">有效截止时间</van-col>
                            <van-col span="12" style="text-align: right">{{item.effectiveTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>


                    </van-cell>
<!--                        <template #right>-->
<!--                            <van-button plain  type="danger" text="删除" @click="removeTurck(item.truckproveId,item.status)"/>-->
<!--                        </template>-->
<!--                    </van-swipe-cell>-->

                </van-list>
            </van-pull-refresh>
        </div>



        <van-popup v-model="showpop" :lazy-render=false position="right" :style="{ height: '100%', width:'100%'}" >


            <div class="editwarp">
                <van-cell  >
                    <div style="text-align: center;font-size: 18px;margin-top:15px;">
                        {{infoDetail.ouName}}
                    </div>
                    <div id="qrCode"  class="qrcode" ref="qrCodeDivOut"  v-if="qrShow"></div>
                    <div id="qrCodeno" class="qrcode" v-if="qrNotShow" style="    position: relative;">
                        <div style="background-color:white; opacity: 0.9;width:180px;height:190px;margin-top:-200px;z-index: 999;">
                            <div style="color:black;background-color:white;font-size: 18px;padding-top: 80px;">无效二维码</div>
                        </div>
                    </div>
                    <div style="text-align: center;font-size: 14px;margin-top:10px;">
                        {{infoDetail.truckproveNo}}
                    </div>
                </van-cell>

                <van-cell  class="swipewarp" style="margin-top: 10px">
                        <div >
                        <van-row gutter="20">
                            <van-col span="19" style="font-weight: bolder;" >{{infoDetail.truckNo}}</van-col>
                            <van-col span="5" style="font-weight: bolder;text-align: right">{{infoDetail.status|capitalize}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="15"  style="color: #727272">驾驶员</van-col>
                            <van-col span="9" style="text-align: right"> {{infoDetail.driverName}}</van-col>
                        </van-row>
                            <van-row gutter="20">
                                <van-col span="15" style="color: #727272" >手机号码</van-col>
                                <van-col span="9" style="text-align: right">{{infoDetail.driverPhonenumber}}</van-col>
                            </van-row>
                        <van-row gutter="20">
                            <van-col span="12" style="color: #727272"><span class="detailLabel">创建时间</span></van-col>
                            <van-col span="12" style="text-align: right">{{infoDetail.createTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12" style="color: #727272"><span class="detailLabel">有效截止时间</span></van-col>
                            <van-col span="12" style="text-align: right">{{infoDetail.effectiveTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12" style="color: #727272"><span class="detailLabel">进场时间</span></van-col>
                            <van-col span="12" style="text-align: right">{{infoDetail.entryTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>
                        <van-row gutter="20">
                            <van-col span="12" style="color: #727272"><span class="detailLabel">离场时间</span></van-col>
                            <van-col span="12" style="text-align: right">{{infoDetail.leaveTime|moment("YYYY-MM-DD HH:mm:ss")}}</van-col>
                        </van-row>
                        </div>
                    </van-cell>

                <van-collapse v-model="activeNames"  style="margin-top: 10px">
                    <van-collapse-item title="提货明细" name="1" style="text-align: left;">
                        <van-list
                                v-model="loading"
                                :finished="finished"
                                finished-text=""
                        >
                            <van-cell class="cellwarp">
                                <van-row gutter="">
                                    <van-col span="20">待发</van-col>
                                </van-row>
                            </van-cell>
                            <van-cell v-for="item in listNotify" :key="item.outnotifyId" class="cellitemwarp"  >
                                    <van-row gutter="20">
                                        <van-col span="12">提货单号</van-col>
                                        <van-col span="12" style="text-align: right">{{item.outnotifyNo}}</van-col>
                                    </van-row>
                                <van-row gutter="20">
                                    <van-col span="12">提货日期</van-col>
                                    <van-col span="12" style="text-align: right">{{item.outnotifyDate}}</van-col>
                                </van-row>

                                    <van-row gutter="20"  v-for="cargoitem in item.cargoList" :key="cargoitem.cargoName">
                                        <van-col span="12">{{cargoitem.cargoName}}</van-col>
                                        <van-col span="12" style="text-align: right">{{cargoitem.amount}}件，{{cargoitem.weight}}吨</van-col>
                                    </van-row>

                                </van-cell>
                            <van-cell  class="cellwarp" style="margin-top: 10px">
                                <van-row gutter="">
                                    <van-col span="20">实发</van-col>
                                </van-row>
                            </van-cell>
                            <van-cell v-for="item in listOut" :key="item.outnotifyId" class="cellitemwarp"  >
                                <van-row gutter="20">
                                    <van-col span="12">出库单号 </van-col>
                                    <van-col span="12" style="text-align: right">{{item.outnotifyNo}}</van-col>

                                </van-row>
                                <van-row gutter="20">
                                    <van-col span="12">货主提单号 </van-col>
                                    <van-col span="12" style="text-align: right">{{item.outnotifyCustomerNo}}</van-col>

                                </van-row>
                                <van-row gutter="20">
                                    <van-col span="12">理货员 </van-col>
                                    <van-col span="12" style="text-align: right">{{item.tallPersonName}}</van-col>

                                </van-row>
                                <van-row gutter="20">
                                    <van-col span="12">发货时间 </van-col>
                                    <van-col span="12" style="text-align: right">{{item.outnotifyDate}}</van-col>

                                </van-row>
                                <van-row gutter="20"  v-for="cargoitem in item.cargoList" :key="cargoitem.cargoName">
                                    <van-col span="12">{{cargoitem.cargoName}}</van-col>
                                    <van-col span="12" style="text-align: right">{{cargoitem.amount}}件，{{cargoitem.weight}}吨</van-col>
                                </van-row>

                            </van-cell>
                        </van-list>

                    </van-collapse-item>

                </van-collapse>
                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="24" >
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="detailDel()">
                            删除
                        </van-button>
                    </van-col>
<!--                    <van-col span="6">-->
<!--                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="onSearch()">-->
<!--                            评价-->
<!--                        </van-button>-->
<!--                    </van-col>-->
<!--                    <van-col span="7">-->
<!--                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="onSearch()">-->
<!--                            查看评价-->
<!--                        </van-button>-->
<!--                    </van-col>-->
                </van-row>
            </div>
        </van-popup>

        <van-popup v-model="searchShowPop" position="right" :style="{ height: '100%', width:'80%'}" >
            <van-nav-bar
                    title="筛选"
                    fixed
                    z-index="9999"
            />
            <div class="searchwarp">
                <van-field v-model="searchValue.keywords" label="关键字"  placeholder="单号\车号\驾驶员\手机号码"  autocomplete="off" label-width="60px"/>
                <van-field v-model="searchValue.from" label="创建日期" readonly="readonly"   placeholder="创建日期"  autocomplete="off" @click="calendarShow=true" label-width="60px"/>
                <van-field name="radio" label="状态" label-width="60px">
                    <template #input>

                        <van-radio-group v-model="searchValue.status" >
                            <van-button v-if="searchValue.status==0"  hairline type="warning" size="small" @click="searchValue.status=0" style="margin-right:5px;margin-top:2px">全部</van-button>
                            <van-button v-else="" plain hairline type="default" size="small" @click="searchValue.status=0" style="margin-right:5px;margin-top:2px">全部</van-button>

                            <van-button  v-if="searchValue.status==10"  hairline type="warning" size="small" @click="searchValue.status=10" style="margin-right:5px;margin-top:2px">预约</van-button>
                            <van-button v-else="" plain hairline type="default" size="small" @click="searchValue.status=10"  style="margin-right:5px;margin-top:2px">预约</van-button>

                            <van-button  v-if="searchValue.status==20"  hairline type="warning" size="small" @click="searchValue.status=20" style="margin-right:5px;margin-top:2px">进场</van-button>
                            <van-button v-else="" plain hairline type="default" size="small" @click="searchValue.status=20" style="margin-right:5px;margin-top:2px">进场</van-button>

                            <van-button v-if="searchValue.status==30"   hairline type="warning" size="small" @click="searchValue.status=30" style="margin-right:5;margin-top:2px">离场</van-button>
                            <van-button  v-else="" plain hairline type="default" size="small" @click="searchValue.status=30" style="margin-right:5px;margin-top:2px">离场</van-button>

                        </van-radio-group>
                    </template>
                </van-field>

                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>

                <van-calendar v-model="calendarShow"
                              :min-date=" new Date(2020, 9, 1)"
                              type="range" @confirm="calendarConfirm" />
            </div>
        </van-popup>

        <van-button class="closebutton" block  size="small" type="info" native-type="submit" style="font-size: 16px;width:100px;margin:auto" @click="saveOut()">
                创建
            </van-button>

    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import {NavBar, Toast, Cell, Button, Icon, Field, Dialog,Collapse, CollapseItem} from 'vant';
    import {List } from 'vant';
    import {Search  } from 'vant';
    import { Col, Row } from 'vant';
    import {SwipeCell } from 'vant';
    import {Popup } from 'vant';
    import {PullRefresh } from 'vant';
    import {Sticky } from 'vant';
    import { RadioGroup, Radio } from 'vant';
    import { Calendar } from 'vant';
    import service from '../../server/index'

    export default {
        name: "MyOut",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Cell.name]: Cell,
            [SwipeCell.name ]:SwipeCell,
            [Button.name]:Button,
            [Popup.name]: Popup,
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]:Radio,
            [Calendar.name]:Calendar,
            [Collapse.name]:Collapse,
            [CollapseItem.name]:CollapseItem
        },
        computed:{
            showStatus(){
                return function(item){
                   if(item.status==10)
                   {
                       return 'yu'
                   }
                    if(item.status==20)
                    {
                        return 'jin'
                    }
                    if(item.status==30)
                    {
                        return 'li'
                    }
                }
            },
            showpop_delbtn(){
                return function(){
                    if(this.showpop && this.infoDetail.status==10){
                        return true;
                    }else{
                        return false;
                    }

                }
            }
        },
        data(){
            return {
                value:"",
                qrcodeContent:"abcabcabc",
                qrShow:true,
                qrNotShow:false,
                show:true,//nav bar
                activeNames:[],
                list: [],
                listNotify:[],
                listOut:[],
                loading:true,
                finished: false,
                showpop:false,
                searchValue:{
                    keywords:"",
                    startTime:"",
                    endTime:"",
                    status:"0"
                },
                searchShowPop:false,
                //编辑
                info:{},
                infoDetail:{},
                //刷新
                isLoading:false,
                page:1,
                //日期选择calendarShow
                calendarShow:false

            }
        },
        mounted() {
            this.onLoad();
            // this.$nextTick(function(){
            //     this.bindQRCode();
            // })
        },
        filters: {
            capitalize: function (value) {
               if(value == 10)
               {
                   return '预约'
               }
                if(value ==20)
                {
                    return '进场'
                }
                if(value == 30)
                {
                    return '离场'
                }
            }
        },
        methods:{
            back(){
                this.$router.replace("/Home/HomeMenu")
            },
            removeTurck(id,status){
                if(status !=10)
                {
                    Toast("只能删除状态为预约的配单")
                    return;
                }
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要删除这条配货信息吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let param = {
                            truckproveId:id
                        }
                        service.delTruckprove(param).then((res)=>{
                            if(res.code=="200"){
                                Toast("删除成功")
                                this.list = [];
                                this.page = 1;
                                this.onLoad();

                            }else{

                                Toast("删除成功:"+res.msg)
                            }

                        }).catch((res)=>{

                            Toast("删除成功:"+res.msg)
                        });


                    })
                    .catch(() => {
                    });
            },
            onSearch(){
                this.list = [];
                this.page = 1;
                this.show=true;
                this.searchShowPop=false;
                this.onLoad();
            },
            onLoad(){

                let param = {
                    keywords:this.searchValue.keywords,
                    startTime:this.searchValue.startTime,
                    endTime:this.searchValue.endTime,
                    status:this.searchValue.status,
                    driverName:localStorage.getItem("personName"),
                    driverPhonenumber:localStorage.getItem("phoneNumber"),
                    createPersonId:localStorage.getItem("personId"),
                    limit:10,
                    page:this.page
                }
                service.searchTruckproveListByDelivery(param).then((res)=>{
                    if(res.code=="200"){
                        if(res.data.length>0){
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        }else{
                            this.finished = true;
                        }


                        // 加载状态结束
                        this.loading = false;
                        this.isLoading=false;
                    }else{
                        this.loading = false;
                        this.finished = true;
                        this.isLoading=false;
                        Toast(res.msg)
                    }

                }).catch((res)=>{
                    this.loading = false;
                    this.finished = true;
                    Toast(res.msg)
                });
            },
            searchPop(){
                this.searchValue= {keywords:"", from:"", to:"", status:"0"};
                this.searchShowPop = true;
            },
            editFleet(item){

                this.infoDetail={"truckproveId":item.truckproveId, "truckproveNo":item.truckproveNo, "status":item.status, "ouName":item.ouName
                    , "driverName":item.driverName, "createTime":item.createTime, "effectiveTime":item.effectiveTime,
                    "truckNo":item.truckNo,"driverPhonenumber":item.driverPhonenumber,"entryTime":item.entryTime,"leaveTime":item.leaveTime}
                if(item.driverName!= localStorage.getItem("personName") ||  item.driverPhonenumber!=localStorage.getItem("phoneNumber")){
                    this.qrNotShow=true;
                }else{
                    this.qrNotShow=false;

                }
                document.getElementById("qrCode").innerHTML = " ";

                let par=[];

                let t = new Date().getTime() + 60 * 1000;   //24小时 * 60分钟 * 60秒 * 1000
                let d = new Date(t);

                let o = {};
                o.bussionType=115
                o.ouid=item.ouid
                o.bussionNo=item.truckproveId
                o.endTime=this.dateFormat("yyyy-MM-dd hh:mm:ss",d);
                par.push( o)
                let str=JSON.stringify(par);
                console.log(str)
                this.qrcodeContent=this.encode64(str)

                this.bindQRCode();


                let param = {
                    "truckproveId":item.truckproveId,
                }
                service.selTruckproveNotify(param).then((res)=>{
                    if(res.code=="200"){
                        this.listNotify=res.data
                    }else{
                        Toast(res.msg)
                    }

                }).catch((res)=>{
                    Toast(res.msg)
                });

                service.selTruckproveOut(param).then((res)=>{
                    if(res.code=="200"){
                        this.listOut=res.data
                    }else{
                        Toast(res.msg)
                    }

                }).catch((res)=>{
                    Toast(res.msg)
                });

                this.showpop = true;


            },
            onRefresh(){
                this.onLoad();

            },
            saveOut(){
                this.$router.push("/AddOut")

            },
            detailDel(){
                if(this.infoDetail.status !=10)
                {
                    Toast("只能删除状态为预约的配单")
                    return;
                }
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要删除吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let param = {
                            truckproveId:this.infoDetail.truckproveId
                        }
                        service.delTruckprove(param).then((res)=>{
                            if(res.code=="200"){
                                Toast("删除成功")
                                this.list = [];
                                this.page = 1;
                                this.onLoad();
                                this.showpop=false;

                            }else{

                                Toast("删除失败:"+res.msg)
                            }

                        }).catch((res)=>{

                            Toast("删除失败:"+res.msg)
                        });


                    })
                    .catch(() => {
                    });

            },

            remove(id){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定要删除这条车辆信息吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let param = {
                            "deliveryTruckId":id,
                        }
                        service.deleteTruck(param).then((res)=>{
                            if(res.code=="200"){
                                this.showpop = false;
                                this.page = 1;
                                this.list = [];
                                this.onLoad();
                            }else{
                                Toast(res.msg)
                            }

                        }).catch((res)=>{
                            Toast(res.msg)
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            },
            bindQRCode(){
                new QRCode(this.$refs.qrCodeDivOut,{
                    text:this.qrcodeContent,
                    width:180,
                    height:180,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                })

            },
            //日期组件
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            calendarConfirm(date){
                const [start, end] = date;
                this.calendarShow = false;
                this.searchValue.from = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                this.searchValue.startTime = this.formatDate(start);
                this.searchValue.endTime = this.formatDate(end);
            },
            resetSearch(){
                this.searchValue= {keywords:"", startTime:"", endTime:"", status:"0"};
            },
            encode64(input){
                // base64加密开始
                let keyStr = "ABCDEFGHIJKLMNOP" + "QRSTUVWXYZabcdef" + "ghijklmnopqrstuv"
                    + "wxyz0123456789+/" + "=";
                let output = "";
                let chr1, chr2, chr3 = "";
                let enc1, enc2, enc3, enc4 = "";
                let i = 0;
                do {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);
                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }
                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
                        + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                } while (i < input.length);

                return output;
            },
            dateFormat(fmt, date) {

                var o = {
                    "M+" : date.getMonth()+1,                 //月份
                    "d+" : date.getDate(),                    //日
                    "h+" : date.getHours(),                   //小时
                    "m+" : date.getMinutes(),                 //分
                    "s+" : date.getSeconds(),                 //秒
                    "q+" : Math.floor((date.getMonth()+3)/3), //季度
                    "S"  : date.getMilliseconds()             //毫秒
                };
                if(/(y+)/.test(fmt))
                    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
                for(var k in o)
                    if(new RegExp("("+ k +")").test(fmt))
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
                return fmt;
            }
        }
    }
</script>

<style scoped>
    .van-cell{

    }
    .van-popup{
        background-color: #f7f8fa;
    }

    .searchwarp{
        margin-top: 40px;
    }
    .editwarp{
        width:100%;
        margin: 56px auto;
    }

    .qrcode{
        margin:10px auto; /* 居中 这个是必须的，，其它的属性非必须 */
        width:180px; /* 给个宽度 顶到浏览器的两边就看不出居中效果了 */
        text-align:center; /* 文字等内容居中 */
    }

    /*.swipewarp{*/
    /*    height: 100px;*/
    /*}*/

    .contentwarp{
        margin-top:46px;
        height: calc(100vh - 50px);
    }

    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
    .closebutton{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 50px;
        height: 50px;
        width: 100% !important;
    }

    .closebutton2{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        z-index: 9999;
    }
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text ,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow{
        color: #6685a4 ;
    }
    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;

    }

    /deep/ .van-button--warning{
        background-color: #6685a4 ;
        border: 1px solid #6685a4 ;

    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end ,
    /deep/ .detailHeader[data-v-1405fac1]{
        background-color: #6685a4;
    }
    /deep/  .van-calendar__day--middle{
        background-color: #e4ebf3;
    }
    /deep/ .van-cell__title{
        text-align: left;
        /*font-weight: bolder;*/
    }

    .cellwarp{
        padding-top:0px;
        padding-bottom: 0px;
        font-weight: bolder;
        padding-left:0px;
    }

    .cellitemwarp{
        padding-top:0px;
        padding-bottom: 0px;
    }
</style>